import { RefreshCw } from 'lucide-react';

export function DrawdownPreviewLoadingState() {
  return (
    <div className="max-w-6xl mx-auto p-6 space-y-6">
      <div className="flex items-center justify-center py-12">
        <RefreshCw className="h-6 w-6 animate-spin mr-2" />
        <span>Loading batches...</span>
      </div>
    </div>
  );
}
